import { gsap, ScrollTrigger, ScrollToPlugin, Observer } from "gsap/all";

if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Observer);
}

const animations = {
  ...gsap,
  ScrollTrigger,
  ScrollToPlugin,
  Observer,
};

export default animations;
